import { pageNavigation } from '@/config/navigation'

/*
  Per-route header metadata derived from the central page navigation config.
*/

/** One step in a navbar breadcrumb trail; the last step is the current page. */
export interface Crumb {
  label: string
  /** Omitted on the last step, which is where the user already is. */
  path?: string
}

export interface PageMeta {
  /** Title shown in the top navbar. */
  title: string
  /** Show the live system-status counters — only meaningful on the Overview. */
  showSystemStats?: boolean
  /**
   * Trail rendered in the navbar *instead of* the title. Drill-downs use it so
   * the header names the system rather than repeating the section it sits under.
   */
  breadcrumb?: readonly Crumb[]
  /** Show the UTC clock in the header — pages whose data is timestamped. */
  showClock?: boolean
}

/** Ordered most-specific first so nested routes win over their parents. */
const routes: { path: string; meta: PageMeta }[] = pageNavigation
  .map((page) => ({
    path: page.path,
    meta: {
      title: page.navbarTitle,
      showSystemStats: page.showSystemStats,
      breadcrumb: page.breadcrumb,
      showClock: page.showClock,
    },
  }))
  .sort((a, b) => b.path.length - a.path.length)

const fallback: PageMeta = { title: 'System Stability' }

/** Resolve header metadata for a pathname, falling back to a generic title. */
export function resolvePageMeta(pathname: string): PageMeta {
  const match = routes.find((r) => pathname === r.path || pathname.startsWith(`${r.path}/`))
  return match?.meta ?? fallback
}
